import React, { useState, useRef } from 'react';
import { Row, Col, Input, Table, Result, message, Spin } from 'antd';
import asyncFetch from '../../utils/asyncFetch';
import { asArray, splitString } from '../../utils/dataGuards';
import { columns } from './columns';
import { useTranslation } from 'react-i18next';

import noResult from '../../images/noResult.png';

const { Search } = Input;

const Tool = () => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [record, setRecord] = useState([]);
    const [visiable, setVisiable] = useState(false); 
    const loadingStartRef = useRef(0);
    const MIN_LOADING_MS = 500;

    const chromRef = useRef(null);
    const positionRef = useRef(null);
    const referenceRef = useRef(null);

    const null_undefault = (value) => {
        if (typeof(value) === "undefined" || value === "") {
            return false
        } else {
            return true
        }
    };

    const finishLoading = (nextVisible, nextRecord) => {
        const elapsed = Date.now() - loadingStartRef.current;
        const delay = elapsed >= MIN_LOADING_MS ? 0 : MIN_LOADING_MS - elapsed;
        setTimeout(() => {
            if (typeof nextRecord !== 'undefined') {
                setRecord(nextRecord);
            }
            if (typeof nextVisible !== 'undefined') {
                setVisiable(nextVisible);
            }
            setLoading(false);
        }, delay);
    };

    const onSearch = (value) => {
        let chrom = chromRef.current.input.value,
        pos = positionRef.current.input.value,
        ref = referenceRef.current.input.value,
        alt = value;
        if(null_undefault(chrom) && null_undefault(pos) && null_undefault(ref) && null_undefault(alt)) {
            loadingStartRef.current = Date.now();
            setLoading(true);
            setVisiable(false);
            setRecord([]);
            loadData(chrom, pos, ref, alt);
        } else {
            message.error({
                content: 'Site info cannot be empty!'
            })
        }
    };

    const loadData = (chrom, pos, ref, alt) => {
        asyncFetch('GET', '/dvpred', {CHROM: chrom, POS: pos, REF: ref, ALT: alt},
            (res) => {
                if(res.code === 200) {
                    const result = asArray(res.data).map((val, idx) => ({ ...(val || {}), key: idx }));
                    finishLoading(result.length > 0, result);
                } else {
                    finishLoading(false, []);
                    message.error(res.msg)
                }
            },
        {}, 'cors', () => finishLoading(false, []), false);
    };

    const handleClick = (e) => {
        const array = splitString(e.currentTarget?.textContent, '-');
        if (array.length < 4) {
            message.error('Invalid example site.');
            return;
        }
        loadingStartRef.current = Date.now();
        setLoading(true);
        setVisiable(false);
        setRecord([]);
        loadData(array[0], array[1], array[2], array[3]);
    };

    return (
        <Row>
            <Col span={24} className="page-top-seize-seat" />
            <Col span={24} className="tool-center dvpred-contain">
                <span className="dvpred-title">DVPred: The Deafness Variant Function Prediction Tool</span>
                <p className="dvpred-description">
                    {t('tool_description')}
                </p>
                <Col span={24}>
                    <Input.Group compact style={{margin: '5.5vh 0 3.5vh 0'}}>
                        <Input
                            style={{
                                width: '20vh',
                                height: '60px',
                                borderRadius: '6px 0 0 6px',
                                border: 'none'
                            }}
                            placeholder="CHROM"
                            ref={chromRef}
                        />
                        <Input
                            style={{
                                width: '5vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="-"
                            disabled
                            className=""
                        />
                        <Input
                            style={{
                                width: '20vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="POS"
                            ref={positionRef}
                        />
                        <Input
                            style={{
                                width: '5vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="-"
                            disabled
                        />
                        <Input
                            style={{
                                width: '20vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="REF"
                            ref={referenceRef}
                        />
                        <Input
                            style={{
                                width: '5vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="-"
                            disabled
                        />
                        <Search
                            style={{
                                width: '20vh',
                                height: '60px',
                                border: 'none'
                            }}
                            placeholder="ALT"
                            size="large"
                            onSearch={onSearch}
                        />
                    </Input.Group>
                </Col>
                Example: 
                <span onClick={handleClick} style={{cursor: 'pointer'}}>16-2550805-G-C</span>
            </Col>
            <Col span={24} className="tool-bottom">
                {loading ? (
                    <div className="tool-loading-panel">
                        <Spin size="large" tip="Loading..." />
                    </div>
                ) : visiable ? (
                    <Table
                        bordered
                        columns={columns}
                        dataSource={record}
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                    />
                ) : (
                    <Result
                        icon={<img src={noResult} alt="Not Data" />}
                        title="Sorry! No relevant data found"
                    />
                )}
            </Col>
        </Row>
    )
}

export default Tool
